import React from 'react';
import ButtonLink from '../../common/TrackedButtonLink';
import ProductImageCTA from '../../common/ProductImageCTA';
import { toPascalCase } from "../../../utils";

const TopProducts = ({ title, subTitle, path, buttonCTA, topProduct }) => {
	//
	//const currentPath = window.location.pathname;
	const currentPath = typeof window !== "undefined" ? window.location.pathname : "/";
	const topProducts = topProduct.map(
		(product, index) => <ProductImageCTA
			key={index}
			imgSrc={product.image}
			hoverImage={product.hoverImage}
			title={product.description}
			listPrice={product.priceBucket}
			fromList={`Top Products on ${currentPath === '/' ? 'home page' : currentPath}`}
			modelNumber={product.modelNumber}
			saleFlag={product.onSale}
			product={product}
		/>
	);
	const buttonId = `ctaTopProducts${toPascalCase(buttonCTA)}`;
	return (
		<section className="row safes-callout">
			<div className="col sm-3 callout-descr">
				<h2 className="section-title">{title}</h2>
				<p>{subTitle}</p>
				<ButtonLink className="btn-primary" id={buttonId} to={`/products/${path}`}>
					{buttonCTA}
				</ButtonLink>
			</div>
			<div className="col sm-9 products">
				<ul>
					{topProducts}
				</ul>
			</div>
		</section>
	);
};

export default TopProducts;


// WEBPACK FOOTER //
// ./src/pages/category/common/TopProducts.js